import { useState, useEffect } from 'react';

export const useResponsive = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        let timeoutId;
        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => setWindowWidth(window.innerWidth), 150);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return {
        windowWidth,
        isSmall: windowWidth <= 480,
        isMobile: windowWidth <= 768,
        isTablet: windowWidth <= 1024,
    };
};
